import {CSSProperties, FC} from 'react';


export interface IIconInstagramProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconInstagram: FC<IIconInstagramProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M11.916 0c6.572 0 11.917 5.346 11.917 11.916s-5.346 11.917-11.916 11.917C5.345 23.833 0 18.487 0 11.917 0 5.345 5.346 0 11.916 0Zm4.158 5.14H7.759a2.622 2.622 0 0 0-2.62 2.62v8.315a2.622 2.622 0 0 0 2.62 2.62h8.315a2.622 2.622 0 0 0 2.62-2.62V7.759a2.622 2.622 0 0 0-2.62-2.62Zm-7.591 5.386c-.175.429-.273.899-.273 1.39a3.711 3.711 0 0 0 3.706 3.707 3.712 3.712 0 0 0 3.707-3.707c0-.491-.099-.961-.275-1.39h2.024v5.549a1.3 1.3 0 0 1-1.299 1.298H7.758c-.716 0-1.299-.581-1.299-1.298v-5.55h2.024Zm3.434-.995c.796 0 1.5.394 1.934.995.282.392.452.871.452 1.39a2.39 2.39 0 0 1-2.387 2.386 2.387 2.387 0 0 1-2.385-2.386c0-.52.17-.999.452-1.39a2.385 2.385 0 0 1 1.934-.995Zm5.208-2.83v2.297l-2.29.008-.007-2.298 1.998-.006.3-.001Z" clipRule="evenodd" />
        </svg>
    );
};
